const BRAND_AVATAR_COLORS = [
  'var(--rwm-cyan)',
  'var(--rwm-blue)',
  'var(--rwm-amber)',
  'var(--rwm-slate)',
  'var(--rwm-salary)',
  'var(--rwm-dark)',
];

export function avatarColor(name) {
  const ch = (name && name.trim()[0]) || 'A';
  return BRAND_AVATAR_COLORS[ch.charCodeAt(0) % BRAND_AVATAR_COLORS.length];
}

export function employeeCountLabel(raw) {
  if (raw == null || String(raw).trim() === '') return null;
  const s = String(raw).trim();
  if (/employees/i.test(s)) return s;
  return `${s.replace(/-/g, '–')} employees`;
}
